import styled from "styled-components";

export const Container = styled.section``;

export const Header = styled.header``;

// title
export const Title = styled.h1`
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #3d0052;
  opacity: 0.62;
  flex: none;
  order: 0;
  flex-grow: 0;
`;
// dynamic title
export const DynamicTitle = styled.p`
  text-transform: capitalize;
  display: inline-block;
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #18181b;
  flex: none;
  order: 2;
  flex-grow: 0;
`;

// filter container
export const FilterContainer = styled.section``;

// table container
export const TableContainer = styled.section.attrs({})``;
